export const profileData = {
  name: "Yash Lathiya",
  title: "Software Engineer",
  tagline: "Building scalable backend systems with focus on performance",
  bio: "I'm a passionate software engineer specializing in low latency data communication, database internals, and system design. I love diving deep into backend development and creating efficient, scalable solutions.",
  interests: [
    "Low Latency Data Communication",
    "Database Internals",
    "System Design",
    "Backend Development"
  ],
  social: {
    github: "https://github.com/yalathiya",
    linkedin: "https://www.linkedin.com/in/yash-a-lathiya",
    email: "yalathiya.it@gmail.com"
  }
};
